import ParallaxScrollingElement from "parent/src/js/base/Controllers/ParallaxScrollingElement";

class ParallaxScrollingElementCollection {

	/**
	 *
	 * @param {string} parallaxContainerSelector
	 */
	constructor(parallaxContainerSelector) {
		/**
		 * @type <NodeListOf<HTMLElement>>
		 */
		this.elements = document.querySelectorAll(parallaxContainerSelector);

		if (this.elements.length > 0) {
			this.init();
		}
	}

	init() {
		this.elements.forEach(item => {
			new ParallaxScrollingElement(item);
		});
	}

}

export default ParallaxScrollingElementCollection;
